// style
export const iconSize = {
	md: 'w-6 h-6 my-auto mx-0',
	lg: '',
}
